module.exports = __webpack_public_path__ + "images/spinner.24976c46bbf8be9db663.svg";